import {Injectable} from '@angular/core';
import {CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Route} from '@angular/router';
import {Observable} from 'rxjs';
import {ClientService} from './client.service';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanLoad {

    token: string;

    constructor(private clientService: ClientService, private router: Router) {
        this.token = localStorage.getItem('token');
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        if (this.clientService.userLogedin()){
            return true;
        }

        this.router.navigateByUrl('');
        return false;
    }

    canLoad(route: Route): boolean {
        if (this.clientService.userLogedin()) {
            return true;
        }
        this.router.navigateByUrl('');
        return false;
    }

}
